<template lang="pug">
div
  .table-wrapper
    .scrollable
      AppTable(
        ref="table"
        hoverable
        :loading="showLoading"
        :table-data="members"
      )
        template(#empty)
          .text-lighter.mt-20 0 members

        AppTableColumn(
          v-slot="{ row }"
          header="Member"
        )
          .member-container
            PopoverAvatar(
              :user-id="row.id"
              :organization-id="organization.id"
            )
            .member-name(
              :key="row.id"
              v-tooltip="{ html: true }"
              :title="row.email"
            )
              | {{ row.name }}
        AppTableColumn(
          v-slot="{ row }"
          header="Status"
        )
          .two-factor-auth-status
            .configured(v-if="row.enabled_2fa")
              i.hi-lock
              | Configured
            .not-configured(v-else)
              i.hi-info-filled
              | Not configured
        AppTableColumn(
          v-slot="{ row }"
          header="Manage"
          :header-tooltip="RESET_2FA_TOOLTIP"
        )
          .two-factor-auth-reset(v-if="row.enabled_2fa")
            a.clickable(
              v-if="row.can_disable_2fa"
              @click="openConfirmDialog(row)"
            ) Reset
            span.text-muted(
              v-else
              v-tooltip
              :title="CANNOT_RESET_2FA_TOOLTIP"
            ) Reset
      AppPagination(
        v-if="showPagination"
        :pagination="pagination"
        :resource="{ one: 'member', many: 'members' }"
        @page-changed="onPageChanged"
      )
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { CONSTANTS } from '~/app_constants';
import PopoverAvatar from '~/components/PopoverAvatar.vue';
import AppPagination from '~/components/AppPagination.vue';

const RESET_2FA_TOOLTIP = CONSTANTS.reset2faTooltip;
const CANNOT_RESET_2FA_TOOLTIP = CONSTANTS.cannotReset2faTooltip;

export default {
  name: 'MfaSettingsMembersTable',
  components: {
    PopoverAvatar,
    AppPagination,
  },
  data: () => ({
    RESET_2FA_TOOLTIP,
    CANNOT_RESET_2FA_TOOLTIP,
  }),
  computed: {
    ...mapState(['members', 'organization', 'pagination']),
    ...mapGetters(['showLoading']),
    showPagination() {
      return this.pagination?.total_pages > 1;
    },
  },
  methods: {
    openConfirmDialog(user) {
      this.$emit('open-confirm-dialog', user);
    },
    onPageChanged(page) {
      this.$emit('page-changed', page);
    },
  },
};
</script>
